<template>
  <page-content>
    <div class="col-middle">
      <div class="text-center text-center">
        <h1 class="error-number"><i class="fad fa-laugh"></i></h1>
        <h2>Chúc bạn một ngày làm việc vui vẻ!</h2>
        <div class="mid_center">
          <h3></h3>
        </div>
      </div>
    </div>
  </page-content>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>

</style>